import { useEffect, useRef, useState, lazy, Suspense } from 'react';

const TextField = lazy(() => import('@mui/material/TextField'));
const InputAdornment = lazy(() => import('@mui/material/InputAdornment'));
const IconButton = lazy(() => import('@mui/material/IconButton'));
const OutlinedInput = lazy(() => import('@mui/material/OutlinedInput'));
const FormHelperText = lazy(() => import('@mui/material/FormHelperText'));
const FormControl = lazy(() => import('@mui/material/FormControl'));
const InputLabel = lazy(() => import('@mui/material/InputLabel'));

//const Visibility = lazy(() => import('@mui/icons-material/Visibility'));
import Visibility from '@mui/icons-material/Visibility';
//const VisibilityOff = lazy(() => import('@mui/icons-material/VisibilityOff'));
import VisibilityOff from '@mui/icons-material/VisibilityOff';
const DeleteIcon = lazy(() => import('@mui/icons-material/Delete'));
const CopyIcon = lazy(() => import('@mui/icons-material/ContentCopy'));

import { inputLabelClasses } from "@mui/material/InputLabel";

import { getColors, getDarkMode } from '@/utils/Settings';

export default function Input({
    t,
    type = 'text',
    id,
    ref,
    name,
    value,
    className,
    autoComplete,
    required,
    isFocused,
    onChange,
    placeholder,
    explanation,
    readOnly,
    disabled,
    error,
    multiline,
    rows,
    maxRows,
    maxLength,
    handleKeyDown,
    handleKeyUp,
    handleFileRemove,
    accept,
    shrink,
    capture,
    variant,
    size,
    multiple
    //sx
}){

    const {lightColor,darkColor,lightColorGradient,darkColorGradient} = getColors();
    const darkmode = getDarkMode();

    var input = useRef(null);
    if(ref){
        input = ref;
    }
    
    useEffect(() => {
        if(isFocused && input.current){
            input.current.focus();
        }
    }, [input]);

    var classString = '';
    if(!className || className.length === 0){
        classString = 'app-input';
    }
    else{
        classString = className;
    }

    if(disabled){
        classString = classString+' app-input-disabled';
    }

    if(readOnly){
        classString = classString+' app-input-readonly';
    }

    var inputProperties = {
        className: classString,/*
        sx: {
            '&::placeholder': {
              fontStyle: 'italic',
              color: 'red'
            }
        }*/
    };

    var variantType = 'outlined';
    if(variant){
        variantType = variant;
    }

    if(readOnly){
        inputProperties.readOnly = readOnly;
    }

    if(maxLength){
        inputProperties.maxLength = maxLength;
    }

    if(accept){
        inputProperties.accept = accept;
    }

    if(multiple){
        inputProperties.multiple = multiple;
    }

    if(type === 'float'){
        inputProperties.maxLength = 2;
    }

    if(type === 'file' || type === 'filewithdeletebutton'){
        inputProperties.style = { 
            cursor: 'pointer' 
        };
    }
    
    const sxInputLabel = {
        // set the color of the label when not shrinked
        //color: "red",
        [`&.${inputLabelClasses.shrink}`]: {
            // set the color of the label when shrinked (usually when the TextField is focused)
            color: darkmode ? darkColor : lightColor
        }
    };

    if(type === 'filewithdeletebutton'){
        //sxInputLabel.position = 'absolute';
        sxInputLabel.paddingLeft = '14px';
        sxInputLabel.top = '15px';
        sxInputLabel.zIndex = 2;
        //sxInputLabel.transform = 'translate(0, -6px) scale(0.75)';

        if (shrink) {
            // Mueve la etiqueta a la posición superior
            //sxInputLabel.top = '0px'; 
            
            // 1. Añade fondo y padding para crear el 'corte' visual
            //sxInputLabel.backgroundColor = 'white'; // O el color de fondo de tu superficie
            //sxInputLabel.padding = '0 6px'; // 6px de padding horizontal para cubrir el borde
            
            // 2. Asegura que la transformación esté aplicada (si no la aplicas en el JSX)
            // sxInputLabel.transform = 'translate(0, -6px) scale(0.75)'; 
            //sxInputLabel.width = '95px';
        }
    }

    const inputLabelProperties = {
        sx: sxInputLabel
    };

    /*
    var inputLabelProperties = {
        style: { color: '#FF8C00'}
    };
    */

    if(type === 'datetime' || type === 'datetime_offset'){
        type = 'datetime-local';
    }

    if(type === 'hour'){
        type = 'time';
    }

    if(shrink || type === 'date' || type === 'datetime-local'){
        inputLabelProperties.shrink = true;
    }

    const [ showPassword, setShowPassword ] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword((show) => !show);
    }

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const [ copied , setCopied ] = useState('');

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        setCopied(t('trans.Copied'));
    };
    /*
    var sx = {
        // Root class for the input field
        "& .MuiOutlinedInput-root": {
            // Class for the border around the input field
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#2e2e2e",
                //borderWidth: "2px",
            },
        },
        // Class for the label of the input field
        //"& .MuiInputLabel-outlined": {
        //    borderColor: "#2e2e2e"
        //},
        /*
        "&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2e2e2e"
        },
        "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "red"
        },                    
        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "purple"
        },*/
    /*}
    */
    var sxString = {
        "& .MuiInputBase-root.MuiOutlinedInput-root.Mui-error": {
            backgroundColor: darkmode ? darkColorGradient : lightColorGradient
        }        
    };

    if(type === 'multiline' || multiline){

        if(readOnly){
            sxString = {...sxString,
                "& .MuiInputBase-root.MuiOutlinedInput-root" : {
                    backgroundColor: 'rgb(0,0,0,0.05)'
                }
            };
        }
        else{
            sxString = {...sxString,
                "& .MuiInputBase-root.MuiOutlinedInput-root" : {                
                    boxShadow: '0 0 #0000,0 0 #0000,0 0 #0000,0 0 #0000,0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)'
                },
                "& .MuiInputBase-root.MuiOutlinedInput-root textarea" : {                
                    boxShadow: 'none'
                }
            };
        }
    }

    if(type === 'filewithdeletebutton' || type === 'copy' || type === 'password'){

        if(type === 'filewithdeletebutton'){
            sxString["& .MuiInputBase-input"] = {paddingTop:'10px',paddingLeft:1.5,paddingBottom:1};
        }
        else{
            sxString["& .MuiInputBase-input"] = {paddingTop:'22px',paddingLeft:1.5,paddingBottom:0.6};
        }

        if(darkmode){
            sxString.backgroundColor = "rgb(115 115 115)";
        }
        else{
            sxString.backgroundColor = "#FFFFFF";            
        }
    }

    var sxIcon = {};
    if(darkmode){
        sxIcon = {
            color: '#FFFFFF'
        };
    }

    var sizeString = 'small';
    if(size){
        sizeString = size;
    }

    return (            
        type === 'int' ?
            <Suspense>
                <TextField 
                    size={sizeString}
                    sx={sxString}
                    variant={variantType}
                    inputRef={input}
                    id={id}
                    name={name}
                    type="number"
                    step="1"
                    min="0"                           
                    autoComplete={autoComplete}
                    placeholder={explanation && explanation?.length > 0 ? explanation : shrink ? null : placeholder}
                    label={placeholder} 
                    InputLabelProps={inputLabelProperties}
                    required={required}
                    disabled={disabled}
                    //defaultValue={value}
                    value={value === null ? '' : value}
                    error={error && error.length > 0 ?true:false}
                    helperText={error && error.length > 0 ? error : ''}
                    inputProps={inputProperties}
                    onChange={onChange} 
                    onKeyDown={handleKeyDown}  
                    onKeyUp={handleKeyUp}
                    fullWidth                     
                /> 
            </Suspense>
        :
            type === 'float' ?
                <Suspense>
                    <TextField 
                        size={sizeString}
                        sx={sxString}
                        variant={variantType}
                        inputRef={input}
                        id={id}
                        name={name}                    
                        type="number"
                        step="0.01"
                        min="0"                           
                        autoComplete={autoComplete}
                        placeholder={explanation && explanation?.length > 0 ? explanation : shrink ? null : placeholder}
                        label={placeholder}
                        InputLabelProps={inputLabelProperties}                             
                        required={required}
                        disabled={disabled}
                        //defaultValue={value}
                        value={value === null ? '' : value}
                        error={error && error.length > 0 ?true:false}
                        helperText={error && error.length > 0 ? error : ''}
                        inputProps={inputProperties}
                        onChange={onChange}
                        onKeyDown={handleKeyDown}
                        onKeyUp={handleKeyUp}
                        fullWidth
                    />    
                </Suspense>                    
            :
                type === 'password' ?
                    
                        <FormControl variant={variantType} fullWidth>
                            <InputLabel 
                                sx={sxInputLabel} 
                                {...(shrink ? {shrink:true} : {})} // shrink={true}
                            >
                                {placeholder}
                            </InputLabel>
                            <OutlinedInput                                 
                                {...(shrink ? {notched:true} : {notched:false})}
                                sx={sxString}
                                inputRef={input}
                                id={id}
                                name={name}
                                type={showPassword ? 'text' : 'password'}
                                autoComplete={autoComplete}
                                placeholder={explanation && explanation?.length > 0 ? explanation : placeholder}
                                label={placeholder}                                  
                                required={required}
                                disabled={disabled}
                                //defaultValue={value} 
                                value={value === null ? '' : value}
                                error={error && error.length > 0 ?true:false}
                                helpertext={error && error.length > 0 ? error : ''}
                                inputProps={inputProperties}                            
                                onChange={onChange}
                                fullWidth
                                onKeyDown={handleKeyDown}
                                onKeyUp={handleKeyUp}
                                endAdornment={
                                    <InputAdornment 
                                        position=""                                        
                                    >
                                        <IconButton       
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            edge="end"                                            
                                        >
                                            {showPassword ? <VisibilityOff sx={sxIcon}/> : <Visibility sx={sxIcon}/>}
                                        </IconButton>
                                    </InputAdornment>
                                }

                            />
                            {error && error.length > 0 && (
                                <Suspense>
                                    <FormHelperText error id="accountId-error">
                                      {error}
                                    </FormHelperText>
                                </Suspense>
                            )}
                        </FormControl>
                    
                :               
                    type === 'copy' ?
                        <Suspense>
                            <FormControl variant={variantType} fullWidth>
                                <InputLabel sx={sxInputLabel}>
                                    {placeholder}
                                </InputLabel>
                                <OutlinedInput     
                                    sx={sxString}                          
                                    inputRef={input}
                                    id={id}
                                    name={name}
                                    type='text'
                                    autoComplete={autoComplete}
                                    placeholder={explanation && explanation?.length > 0 ? explanation : placeholder}
                                    label={placeholder}       
                                    required={required}
                                    disabled={disabled}
                                    //defaultValue={value} 
                                    value={value === null ? '' : value}
                                    error={copied && copied.length > 0 ? true : false}
                                    helperText={copied && copied.length > 0 ? copied : ''}
                                    inputProps={inputProperties}
                                    onChange={onChange}
                                    fullWidth                                
                                    onKeyDown={handleKeyDown}
                                    onKeyUp={handleKeyUp}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => handleCopy(value)}                                            
                                                edge="end"
                                            >
                                                <CopyIcon sx={sxIcon}/>
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                                {copied && copied.length > 0 && (
                                    <Suspense>
                                        <FormHelperText error id="">
                                          {copied}
                                        </FormHelperText>
                                    </Suspense>
                                )}
                            </FormControl>
                        </Suspense>
                    :
                        type === 'file' ?
                            <Suspense>
                                <TextField 
                                    size={sizeString}
                                    sx={sxString}
                                    variant={variantType}                                    
                                    inputRef={input}
                                    id={id}
                                    name={name}
                                    type={type}                            
                                    autoComplete={autoComplete}
                                    placeholder={explanation && explanation?.length > 0 ? explanation : shrink ? null : placeholder}
                                    label={placeholder}     
                                    InputLabelProps={inputLabelProperties}  
                                    required={required}
                                    disabled={disabled}
                                    error={error && error.length > 0 ?true:false}
                                    helperText={error && error.length > 0 ? error : ''}
                                    inputProps={inputProperties}                                    
                                    onChange={onChange}
                                    onKeyDown={handleKeyDown}
                                    onKeyUp={handleKeyUp}
                                    fullWidth
                                />
                            </Suspense>                
                        :
                            type === 'filewithdeletebutton' ?
                                <Suspense>
                                    <InputLabel 
                                        sx={sxInputLabel} 
                                        {...(shrink ? {shrink:true} : {})}
                                    >
                                        {placeholder}
                                    </InputLabel>
                                    <OutlinedInput  
                                        {...(shrink ? {notched:true} : {notched:false})}
                                        sx={sxString}                             
                                        inputRef={input}
                                        id={id}
                                        name={name}
                                        type={type}
                                        capture={capture}
                                        autoComplete={autoComplete}
                                        InputLabelProps={inputLabelProperties}
                                        //placeholder={explanation && explanation?.length > 0 ? explanation : placeholder}
                                        //label={placeholder}       
                                        required={required}
                                        disabled={disabled}
                                        error={error && error.length > 0 ?true:false}
                                        helperText={error && error.length > 0 ? error : ''}
                                        inputProps={inputProperties}
                                        onChange={onChange}
                                        fullWidth                            
                                        endAdornment={
                                            handleFileRemove ?
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => handleFileRemove(name)}
                                                        edge="end"
                                                    >
                                                        <DeleteIcon sx={sxIcon}/>
                                                    </IconButton>
                                                </InputAdornment>
                                            :
                                                null
                                        }
                                    />   
                                </Suspense>                    
                            :
                                type === 'multiline' ?
                                    <Suspense>
                                        <TextField 
                                            sx={sxString}
                                            variant={variantType}
                                            inputRef={input}
                                            id={id}
                                            name={name}
                                            type={type}                            
                                            autoComplete={autoComplete}
                                            placeholder={explanation && explanation?.length > 0 ? explanation : shrink ? null : placeholder}
                                            label={placeholder}       
                                            required={required}
                                            disabled={disabled}
                                            //defaultValue={value} 
                                            value={value === null ? '' : value}                                                       
                                            error={error && error.length > 0 ?true:false}
                                            helperText={error && error.length > 0 ? error : ''}
                                            inputProps={inputProperties}
                                            InputLabelProps={inputLabelProperties}
                                            onChange={onChange}
                                            multiline
                                            rows={rows}
                                            maxRows={maxRows}
                                            fullWidth                            
                                        />
                                    </Suspense>
                                :
                                    (type === 'html' || type === 'html_multiline') ?
                                        (readOnly || disabled) ?
                                            <>
                                            <div className='text-xs app-color pl-3'>{placeholder}</div>
                                            {
                                                value && value.length > 0 ?
                                                    <div 
                                                        className='border rounded border-gray-300 p-2 bg-gray-100' 
                                                        dangerouslySetInnerHTML={{__html: value}}
                                                    ></div>
                                                :
                                                    <TextField
                                                        size={sizeString}
                                                        disabled={true} 
                                                        inputProps={{className: 'app-input app-input-readonly'}}
                                                        fullWidth
                                                    />
                                            }
                                            </>
                                        :
                                            <Suspense>
                                                <TextField 
                                                    sx={sxString}
                                                    variant={variantType}
                                                    inputRef={input}
                                                    id={id}
                                                    name={name}
                                                    type={type}                            
                                                    autoComplete={autoComplete}
                                                    placeholder={explanation && explanation?.length > 0 ? explanation : placeholder}
                                                    label={placeholder}       
                                                    required={required}
                                                    disabled={disabled}
                                                    //defaultValue={value} 
                                                    value={value === null ? '' : value}                                                       
                                                    error={error && error.length > 0 ?true:false}
                                                    helperText={error && error.length > 0 ? error : ''}
                                                    inputProps={inputProperties}
                                                    InputLabelProps={inputLabelProperties}                                            
                                                    onChange={onChange}
                                                    multiline={type === 'html_multiline' ? true : false}
                                                    rows={rows}
                                                    maxRows={maxRows}
                                                    fullWidth                            
                                                />
                                            </Suspense>
                                    :
                                        type === 'hidden' ?
                                            <Suspense>
                                                <TextField          
                                                    sx={{display:'none'}}                               
                                                    inputRef={input}
                                                    id={id}
                                                    name={name}
                                                    type={type}
                                                    value={value === null ? '' : value}
                                                />
                                            </Suspense>
                                        :
                                            <Suspense>
                                                <TextField 
                                                    size={sizeString}
                                                    sx={sxString}
                                                    variant={variantType}                                    
                                                    inputRef={input}
                                                    id={id}
                                                    name={name}
                                                    type={type}                            
                                                    autoComplete={autoComplete}
                                                    placeholder={explanation && explanation?.length > 0 ? explanation : shrink ? null : placeholder}
                                                    label={placeholder}     
                                                    InputLabelProps={inputLabelProperties}  
                                                    required={required}
                                                    disabled={disabled}
                                                    //defaultValue={value}  
                                                    value={value === null ? '' : value}
                                                    error={error && error.length > 0 ?true:false}
                                                    helperText={error && error.length > 0 ? error : ''}
                                                    inputProps={inputProperties}
                                                    onChange={onChange}
                                                    onKeyDown={handleKeyDown}
                                                    onKeyUp={handleKeyUp}
                                                    fullWidth
                                                />
                                            </Suspense>
    );
}
